import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import CmsService from 'services/CMS';
import TagManagerService from 'services/TagManager';
import Link from 'components/Link';
import ImageLoad from 'components/ImageLoad';
import style from './style.scss'; //NOSONAR

const GridSolidFunds = (props) => {
    const {data, dateServer} = props;
    if(!data || !data.active) return false;
    let sections = data?.sections &&  Object.values(data?.sections).filter(item => CmsService.validDatesItem(item, dateServer)).slice(0, 4);
    const title = data?.title;

    useEffect(() => {
        promotionView();
    }, [])

    const promotionView = () => {
        let gtm = [];
        sections && sections.map((item, i) => {
            gtm.push({
                id: item.image || title,
                name: title,
                creative: 'Grid-Solid-Funds ' + data.position,
                position: 'slot'+(i+1)
            })
        })
        TagManagerService.promotionsImpressions(gtm)
    }

    const promotionsClick = (info) => {
        TagManagerService.promotionsClick( info, 'slot' + info.position, 'Grid-Solid-Funds '+ info.position );  
    }
    if(sections && sections.length < 4) return '';
    return(
        <section className='grid-solid-funds'>
            <h1 className='grid-solid-funds-title'>{title}</h1>
            <div className='grid-solid-funds-container'>
                {(sections) && sections.map((item, i) => {
                    item.url_banner = item.url
                    item.id = item.image || title;
                    item.name = title || item.image
                    item.position = 'slot'+(i+1);
                    item.creative = 'Grid-Solid-Funds ' + data.position;

                    if(item.text){
                        return(
                            <Link className={'grid-solid-funds-link ' + (item.color ? item.color : '')} to={item.url} target={item.url_target} key={i} onClick={() => promotionsClick(item)} >{item.text}</Link>
                        )
                    } else {
                        return(
                            <Link className={'grid-solid-funds-url '} to={item.url} target={item.url_target} key={i} onClick={() => promotionsClick(item)} >
                                <ImageLoad src={item.image} alt={item.image} key={i} />
                            </Link>
                            
                        ) 
                    }
                })}
            </div>
        </section>
    )
}

GridSolidFunds.propTypes = {
    data: PropTypes.shape({
        active: PropTypes.bool,
        title: PropTypes.string,
        start_date: PropTypes.string,
        end_date: PropTypes.string,
        position: PropTypes.number,
        sections: PropTypes.object
    }),
    dateServer: PropTypes.number,
}

export default GridSolidFunds;